import {
	ITEM_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';

import { Goals } from './Goals';

enum Experiments {
	VC_REDIRECT = 'AB-experiment-vc_redirect',
}

interface Experiment {
	name: Experiments;
	variants: ExperimentVariant[];
	goals: Goals[];
	trackers?: any;
}

interface ExperimentVariant {
	name: string;
	weight: number;
}

export const experiments: Experiment[] = [
	{
		name: Experiments.VC_REDIRECT,
		variants: [
			{ name: 'default', weight: 50 },
			{ name: 'promptuary', weight: 50 },
		],
		goals: [Goals.PROMPTUARY_CREATED],
		trackers: {
			subscope: SUBSCOPE_TYPE.Conference,
			item: ITEM_TYPE.Redirect,
		},
	},
];
